import React, { useState } from 'react';

interface Segment {
  value: number;
  color: string;
  label: string;
}

interface DonutChartProps {
  size?: number;
  strokeWidth?: number;
  segments: Segment[];
}

const DonutChart: React.FC<DonutChartProps> = ({
  size = 100,
  strokeWidth = 10,
  segments,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);

  let offset = 0;
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="relative flex items-center justify-center">
      
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="transform -rotate-90"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="lightgray"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {segments.map((segment, index) => {
          const strokeDasharray = `${(segment.value / total) * circumference} ${circumference}`;
          const strokeDashoffset = offset;

          offset -= (segment.value / total) * circumference;

          return (
            <circle
              key={index}
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke={segment.color}
              strokeWidth={strokeWidth}
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              fill="none"
              style={{
                transition: 'stroke-dashoffset 0.5s ease, stroke 0.5s ease',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            />
          );
        })}
      </svg>
      {hoveredIndex !== null && (
        <div
          className="absolute flex items-center justify-center text-center"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            backgroundColor: 'white',
            borderRadius: '4px',
            padding: '4px 8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
        >
          {segments[hoveredIndex].label}
        </div>
      )}
    </div>
  );
};

export default DonutChart;
